require.register("documenteditor/controllers/referencesCtrl", function(exports, require, module){
  $0
  
});

